define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"csi/xml"
], function(declare,Copy,xml) {
	
	return declare(Copy, {
	
		/**
		 * @override
		 * Add the matrix values to the call
		 */
		toWriterRequest: function () {
			const call = this.inherited(arguments);
			const fd = this.getFormData();
			const matrixValues = fd.matrixEditor.get("value").flat(1);
			call.addParameter("QuantityPerSize", "int"+xml.ATTR_LIST, matrixValues);
			return call;
		}
	});
});